import React, { Component } from 'react';

import Container from '../components/common/application_container';
import axiosInstance from '../config/axiosConfig';
import { SERVER_LISTING_URL } from '../config/rest_endpoints';
import { getUser } from '../actions/session';
import CustomLoader from '../components/common/loader';
import CustomModal from '../components/common/modal';
import AddServerConfig from './addServerCOnfig';
import EditServerConfig from './editServerConfig';
import DeleteServerConfig from './deleteServerConfig';
import Pagination from 'react-js-pagination';
import { Notifications } from '../components/common/notification';

/**
 * ServerMain - Premium Server Configuration Page
 *
 * Displays server configurations in a beautifully animated table.
 */
class ServerMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      User: getUser(),
      serverListing: [],
      isGetting: false,
      isAddModal: false,
      isEditModal: false,
      previousData: {},
      deleteData: {},
      isDeleteModal: false,
      activePage: 1,
      itemsCount: 10,
      totalCount: 0,
      searchTerm: ''
    };
    this.openAddModal = this.openAddModal.bind(this);
    this.closeAddModal = this.closeAddModal.bind(this);
    this.openEditModal = this.openEditModal.bind(this);
    this.closeEditModal = this.closeEditModal.bind(this);
    this.getServerListing = this.getServerListing.bind(this);
    this.openDeleteModal = this.openDeleteModal.bind(this);
    this.closeDeleteModal = this.closeDeleteModal.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    this.getServerListing();
  }

  closeAddModal() {
    this.setState({
      isAddModal: false
    });
  }

  openAddModal() {
    this.setState({
      isAddModal: true
    });
  }

  openEditModal(row) {
    this.setState({
      isEditModal: true,
      previousData: row
    });
  }

  closeEditModal() {
    this.setState({
      isEditModal: false
    });
  }

  closeDeleteModal() {
    this.setState({
      isDeleteModal: false
    });
  }

  openDeleteModal(row) {
    this.setState({
      isDeleteModal: true,
      deleteData: row
    });
  }

  handlePageChange(pageNumber) {
    this.setState(
      {
        activePage: pageNumber
      },
      () => {
        this.getServerListing();
      }
    );
  }

  handleSearch(e) {
    this.setState({ searchTerm: e.target.value });
  }

  getServerListing() {
    const { User, itemsCount, activePage } = this.state;
    if (!User || !User.id) return;
    let userId = User.id;
    this.setState({
      isGetting: true
    });
    // Using axiosInstance which automatically adds auth header and handles 401 errors
    axiosInstance.get(`${SERVER_LISTING_URL}/${userId}/server?page=${activePage}&limit=${itemsCount}`)
      .then((res) => {
        if (res) {
          var resp = res.data.data;
          this.setState({
            serverListing: resp,
            isGetting: false,
            totalCount: res.data.pageinfo.totalCount
          });
        }
      })
      .catch((err) => {
        this.setState({ isGetting: false });
        // 401/JWT expiry is handled by axiosInstance interceptor
        if (err.response && err.response.status !== 401) {
          const alert = err.response;
          if (alert.data && alert.data.message !== 'invalid or expired jwt') {
            Notifications.notify(alert.data.message, 'Failed', 'error');
          }
        }
      });
  }

  renderServerListing() {
    const { serverListing, searchTerm } = this.state;

    if (serverListing == null || serverListing.length === 0) {
      return (
        <tr>
          <td colSpan="5">
            <div
              style={{
                textAlign: 'center',
                padding: '3rem 2rem',
                color: 'var(--color-text-tertiary)'
              }}
            >
              <div style={{ fontSize: '3rem', marginBottom: '1rem', opacity: 0.4 }}>
                <i className="fa fa-server"></i>
              </div>
              <h5
                style={{
                  fontSize: '1rem',
                  fontWeight: 600,
                  color: 'var(--color-text-secondary)',
                  marginBottom: '0.5rem'
                }}
              >
                No Servers Found
              </h5>
              <p style={{ fontSize: '0.875rem', margin: 0 }}>
                Add your first server configuration to get started.
              </p>
            </div>
          </td>
        </tr>
      );
    }

    // Filter based on search
    const filteredData = serverListing.filter(
      (row) =>
        String(row.ip || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        String(row.mask || '').toLowerCase().includes(searchTerm.toLowerCase())
    );

    return filteredData.map((row, idx) => {
      return (
        <tr key={row.id || idx}>

          <td style={{ fontWeight: 500, fontFamily: "'SF Mono', monospace", fontSize: '0.8125rem' }}>
            {row.ip}
          </td>
          <td style={{ fontFamily: "'SF Mono', monospace", fontSize: '0.8125rem' }}>{row.mask}</td>
          <td style={{ fontFamily: "'SF Mono', monospace", fontSize: '0.8125rem' }}>{row.port}</td>
          <td>
            {row.enabled === false ? (
              <span
                className="badge badge-danger"
                style={{
                  background: 'rgba(239, 68, 68, 0.1)',
                  color: '#EF4444',
                  border: '1px solid rgba(239, 68, 68, 0.15)',
                  padding: '0.25rem 0.625rem',
                  borderRadius: '9999px',
                  fontSize: '0.6875rem',
                  fontWeight: 600
                }}
              >
                Disabled
              </span>
            ) : (
              <span
                className="badge badge-success"
                style={{
                  background: 'rgba(16, 185, 129, 0.1)',
                  color: '#10B981',
                  border: '1px solid rgba(16, 185, 129, 0.15)',
                  padding: '0.25rem 0.625rem',
                  borderRadius: '9999px',
                  fontSize: '0.6875rem',
                  fontWeight: 600
                }}
              >
                Enabled
              </span>
            )}
          </td>
          <td>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <button
                onClick={this.openEditModal.bind(this, row)}
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: 8,
                  border: 'none',
                  background: 'transparent',
                  color: '#6366F1',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <i className="fa fa-edit"></i>
              </button>
              <button
                onClick={this.openDeleteModal.bind(this, row)}
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: 8,
                  border: 'none',
                  background: 'transparent',
                  color: '#EF4444',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <i className="fa fa-trash"></i>
              </button>
            </div>
          </td>
        </tr>
      );
    });
  }

  render() {
    const {
      isGetting,
      isAddModal,
      isEditModal,
      isDeleteModal,
      previousData,
      deleteData,
      activePage,
      itemsCount,
      totalCount,
      searchTerm
    } = this.state;

    let addServer = {
      details: {
        info: 'Add Server',
        msg: <AddServerConfig serverListing={this.getServerListing} close={this.closeAddModal} />
      },
      confirmBtn: { label: 'Update', action: '' },
      crossBtn: { action: this.closeAddModal },
      cancelBtn: { label: 'Cancel', action: this.closeAddModal }
    };
    let editServer = {
      details: {
        info: 'Update Server',
        msg: (
          <EditServerConfig
            previousDetails={previousData}
            serverListing={this.getServerListing}
            close={this.closeEditModal}
          />
        )
      },
      confirmBtn: { label: 'Update', action: '' },
      crossBtn: { action: this.closeEditModal },
      cancelBtn: { label: 'Cancel', action: this.closeEditModal }
    };
    let deleteServer = {
      details: {
        info: 'Delete Server',
        msg: (
          <DeleteServerConfig
            deleteDetails={deleteData}
            serverListing={this.getServerListing}
            close={this.closeDeleteModal}
          />
        )
      },
      confirmBtn: { label: 'Update', action: '' },
      crossBtn: { action: this.closeDeleteModal },
      cancelBtn: { label: 'Cancel', action: this.closeDeleteModal }
    };

    return (
      <Container icon="fas fa-server" title="Server" subTitle="Configuration">
        <CustomModal
          visibility={isAddModal}
          customBodyCSS={'h20'}
          details={addServer.details}
          showBtns={false}
          cancelBtn={addServer.cancelBtn}
          crossBtn={addServer.crossBtn}
        />
        <CustomModal
          visibility={isEditModal}
          details={editServer.details}
          showBtns={false}
          cancelBtn={editServer.cancelBtn}
          crossBtn={editServer.crossBtn}
        />
        <CustomModal
          visibility={isDeleteModal}
          customBodyCSS={'h20'}
          details={deleteServer.details}
          showBtns={false}
          cancelBtn={deleteServer.cancelBtn}
          crossBtn={deleteServer.crossBtn}
        />

        <div className="card" style={{ animation: 'fadeInUp 0.5s ease' }}>

          <div className="card-body" style={{ padding: '1.5rem' }}>
            {/* Header */}
            <div
              className="datatable-header"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '1.25rem',
                gap: '1rem',
                flexWrap: 'wrap'
              }}
            >
              {/* Search */}
              <div style={{ position: 'relative' }}>
                <i
                  className="fa fa-search"
                  style={{
                    position: 'absolute',
                    left: '1rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: 'var(--color-text-tertiary)',
                    fontSize: '0.875rem'
                  }}
                ></i>
                <input
                  type="search"
                  value={searchTerm}
                  onChange={this.handleSearch}
                  placeholder="Search servers..."
                  style={{
                    paddingLeft: '2.5rem',
                    paddingRight: '1rem',
                    height: 42,
                    borderRadius: 10,
                    border: '1.5px solid var(--color-border)',
                    fontSize: '0.875rem',
                    width: 280,
                    transition: 'all 150ms ease',
                    outline: 'none'
                  }}
                />
              </div>

              {/* Add Button */}
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.openAddModal}
                style={{
                  background: 'linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)',
                  border: 'none',
                  borderRadius: 10,
                  padding: '0.625rem 1.25rem',
                  fontSize: '0.875rem',
                  fontWeight: 600,
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  boxShadow: '0 2px 8px rgba(99, 102, 241, 0.25)'
                }}
              >
                <i className="fas fa-plus"></i>
                Add Server
              </button>
            </div>

            {/* Table */}
            <div
              className="datatable-scroll"
              style={{
                border: '1px solid var(--color-border)',
                borderRadius: 12,
                overflow: 'hidden'
              }}
            >
              <table className="table" style={{ marginBottom: 0 }}>
                <thead>
                  <tr>
                    <th
                      style={{
                        background: 'var(--color-bg-subtle)',
                        fontWeight: 600,
                        fontSize: '0.6875rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                        color: 'var(--color-text-secondary)',
                        padding: '1rem 1.25rem',
                        borderBottom: '1px solid var(--color-border)'
                      }}
                    >
                      IP Address
                    </th>
                    <th
                      style={{
                        background: 'var(--color-bg-subtle)',
                        fontWeight: 600,
                        fontSize: '0.6875rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                        color: 'var(--color-text-secondary)',
                        padding: '1rem 1.25rem',
                        borderBottom: '1px solid var(--color-border)'
                      }}
                    >
                      Mask
                    </th>
                    <th
                      style={{
                        background: 'var(--color-bg-subtle)',
                        fontWeight: 600,
                        fontSize: '0.6875rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                        color: 'var(--color-text-secondary)',
                        padding: '1rem 1.25rem',
                        borderBottom: '1px solid var(--color-border)'
                      }}
                    >
                      Port
                    </th>
                    <th
                      style={{
                        background: 'var(--color-bg-subtle)',
                        fontWeight: 600,
                        fontSize: '0.6875rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                        color: 'var(--color-text-secondary)',
                        padding: '1rem 1.25rem',
                        borderBottom: '1px solid var(--color-border)'
                      }}
                    >
                      Status
                    </th>
                    <th
                      style={{
                        background: 'var(--color-bg-subtle)',
                        fontWeight: 600,
                        fontSize: '0.6875rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                        color: 'var(--color-text-secondary)',
                        padding: '1rem 1.25rem',
                        borderBottom: '1px solid var(--color-border)',
                        width: 100
                      }}
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {isGetting ? (
                    <CustomLoader colSpan={5} size="sm" message="Loading servers..." />
                  ) : (
                    this.renderServerListing()
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalCount > itemsCount && (
              <div
                className="datatable-footer"
                style={{
                  marginTop: '1.25rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
              >
                <span
                  style={{
                    fontSize: '0.8125rem',
                    color: 'var(--color-text-tertiary)',
                    fontWeight: 500
                  }}
                >
                  Showing {(activePage - 1) * itemsCount + 1} to{' '}
                  {Math.min(activePage * itemsCount, totalCount)} of {totalCount} entries
                </span>
                <Pagination
                  activePage={activePage}
                  itemsCountPerPage={itemsCount}
                  totalItemsCount={totalCount}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange.bind(this)}
                />
              </div>
            )}
          </div>
        </div>
      </Container>
    );
  }
}

export default ServerMain;
